(function () {
    'use strict';

    angular
        .module('iMatApp')
        .factory('workflow', workflowService);

    workflowService.$inject = ['$log', '_', "eventService", 'utils', 'guard', 'workspace', 'productFactory', 'productWorkflowFactory', 'materialsService'];

    function workflowService($log, _, eventService, utils, guard, workspace, productFactory, productWorkflowFactory, materialsService) {
        var productWorkflows = {};

        return {
            init: init,
            selectFiles: selectFiles,
            selectModels: selectModels,
            selectProducts: selectProducts,
            cancelProductProcessing: cancelProductProcessing,
            recalculateProductPrice: recalculateProductPrice,
            acceptRepair: acceptRepair,
            declineRepair: declineRepair,
            refreshProduct: refreshProduct,
            duplicate: duplicate,
            applyToAll: applyToAll,
            hasFreeSlots: hasFreeSlots
        };

        // -------------------------------------------------------------------------------------

        function init() {
            setupMaterialsAndColours()
                .then(setDefaultMaterialColourForProducts)
                .then(initMaterialColourForDraftProducts)
                .catch(function () {
                    eventService.notify('generalError', 'MaterialsError');
                });
        }

        function errorExeption(message) {
            this.message = message;
        }

        function selectFiles(files, units) {
            $log.debug("selectFiles. Count:" + files.length + ' units: ' + units);

            if (!areModelsCanBeAdded(files.length)) {
                eventService.notify('generalError', 'tooManyFiles');
                return;
            }

            var products = createProductsByFiles(files, units);
            setDefaultMaterialForProducts(products);

            runProductWorkflows(products);
        }

        function selectModels(modelIds) {
            $log.debug("selectModels. Count:" + modelIds.length);

            if (!areModelsCanBeAdded(modelIds.length)) {
                eventService.notify('generalError', 'tooManyFiles');
                return;
            }

            var products = createProductsByModelIds(modelIds);
            setDefaultMaterialForProducts(products);

            runProductWorkflows(products);
        }

        function selectProducts(products) {
            $log.debug("selectProducts. Count:" + products.length);

            if (!areModelsCanBeAdded(products.length)) {
                eventService.notify('generalError', 'tooManyFiles');
                return;
            }

            initMaterialColourForDraftProducts(products);
            runProductWorkflows(products);
        }

        function cancelProductProcessing(productId) {
            var productWorkflow = productWorkflows[productId];
            if (productWorkflow) {
                productWorkflow.abort();

                delete productWorkflows[productId];
                workspace.removeProductById(productId);
            }
        }

        function recalculateProductPrice(productId) {
            var productWorkflow = productWorkflows[productId];
            if (productWorkflow) {
                productWorkflow.recalculatePrice();
            }
        }

        function acceptRepair(productId) {
            var productWorkflow = productWorkflows[productId];
            if (!productWorkflow) {
                return;
            }

            productWorkflow.acceptRepair()
                .then(function () {
                    processRelatedProducts(productWorkflow.product, function (pw) {
                        pw.refresh();
                    });
                });
        }

        function declineRepair(productId) {
            var productWorkflow = productWorkflows[productId];
            if (!productWorkflow) {
                return;
            }

            productWorkflow.declineRepair()
                .then(function () {
                    processRelatedProducts(productWorkflow.product, function (pw) {
                        pw.refresh();
                    });
                });
        }

        function refreshProduct(productId) {
            var productWorkflow = productWorkflows[productId];
            if (!productWorkflow) {
                return;
            }

            productWorkflow.refresh();
        }

        function duplicate(productId) {
            if (!areModelsCanBeAdded(1)) {
                eventService.notify('generalError', 'tooManyFiles');
                return;
            }

            var sourceProduct = workspace.getProductById(productId);
            if (!sourceProduct.model.id) {
                throw new errorExeption('Model id is required.');
            }

            var sourceIndex = workspace.getProductIndexById(productId);
            var destProduct = productFactory.clone(sourceProduct);
            destProduct.quantity(1);

            var productWorkflow = productWorkflowFactory.create(destProduct);
            productWorkflow.run();

            productWorkflows[destProduct.id] = productWorkflow;
            workspace.insertProduct(destProduct, sourceIndex + 1);
        }

        function applyToAll(productId) {
            var sourceProduct = workspace.getProductById(productId);

            var sourceProductMaterial = sourceProduct.material();
            var sourceProductColour = sourceProduct.colour();

            _.each(workspace.products, function (product) {
                if (product.id === sourceProduct.id) {
                    return;
                }

                product.selectMaterialColour(sourceProductMaterial, sourceProductColour);
            });
        }

        function hasFreeSlots() {
            return getFreeSlotsCount() > 0;
        }

        // ----------------------------------------------------------------------------------------

        function areModelsCanBeAdded(itemsToAddCount) {
            var freeSlots = getFreeSlotsCount();

            return itemsToAddCount <= freeSlots;
        }

        function getFreeSlotsCount() {
            var leftFreeSlots = workspace.settings.maxFilesCount - workspace.products.length;
            return leftFreeSlots;
        }

        function setupMaterialsAndColours() {
            return materialsService.getMaterials(workspace.settings.productTemplateId)
                .then(function (materials) {
                    workspace.materials = materials;
                    return materials;
                });
        }

        function setDefaultMaterialColourForProducts(materials) {
            _.each(workspace.products, function (product) {
                if (product.isMaterialColourDraft()) {
                    return;
                }

                product.material(materials[0]);
            });
        }

        function initMaterialColourForDraftProducts(products) {
            if (workspace.materials.length === 0) {
                return;
            }

            products = products || workspace.products;

            _.each(products, function (product) {
                if (product.isMaterialColourDraft()) {
                    var materialId = product.material().id;
                    var colourId = product.colour().id;

                    var materialColour = workspace.getMaterialColourById(materialId, colourId);
                    if (angular.isObject(materialColour)) {
                        product.initMaterialColour(materialColour.material, materialColour.colour);
                    } else {
                        product.material(workspace.materials[0]);
                    }
                }
            });
        }

        function createProductsByFiles(files, units) {
            var products = _.map(files, function (file) {
                return productFactory.createByFile(file, units);
            });

            return products;
        }

        function createProductsByModelIds(modelIds) {
            var products = _.map(modelIds, function (modelId) {
                return productFactory.createByModelId(modelId);
            });

            return products;
        }

        function setDefaultMaterialForProducts(products) {
            var defaultMaterial = workspace.materials.length > 0 ? workspace.materials[0] : null;
            if (!defaultMaterial) {
                return;
            }

            _.each(products, function (product) {
                product.initMaterialColour(defaultMaterial, defaultMaterial.colours[0]);
            });
        }

        function runProductWorkflows(products) {
            _.each(products, function (product) {
                var productWorkflow = productWorkflowFactory.create(product);
                productWorkflow.run();

                productWorkflows[product.id] = productWorkflow;
                workspace.addProduct(product);
            });
        }

        function processRelatedProducts(product, action) {
            _.chain(productWorkflows)
                .filter(function (pw) {
                    return pw.product.id !== product.id && pw.product.model.id === product.model.id;
                })
                .each(action)
                .value();
        }
    }
}());